import { render, staticRenderFns } from "./process_b.vue?vue&type=template&id=44589628&scoped=true"
import script from "./process_b.vue?vue&type=script&lang=js"
export * from "./process_b.vue?vue&type=script&lang=js"
import style0 from "./process_b.vue?vue&type=style&index=0&id=44589628&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44589628",
  null
  
)

export default component.exports